import { Layout } from "@/layout/index.js";

const topMenuRoutes = [
  {
    path: "/my-address",
    component: Layout,
    hidden: true,
    meta: {
      title: "我的地址",
    },
    children: [
      {
        path: "",
        name: "MyAddress",
        meta: {
          title: "我的地址",
        },
        component: () => import("@/page/myAddress/index.vue"),
      },
    ],
  },
  {
    path: "/operation-manual",
    component: Layout,
    hidden: true,
    meta: {
      title: "操作手册",
    },
    children: [
      {
        path: "",
        name: "OperationManual",
        meta: {
          title: "操作手册",
        },
        component: () => import("@/page/operationManual/index.vue"),
      },
    ],
  },
];

export default topMenuRoutes;
